import { render, staticRenderFns } from "./NoticeOfHearingRspToAppealPg.vue?vue&type=template&id=42ca2f70&scoped=true"
import script from "./NoticeOfHearingRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./NoticeOfHearingRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca2f70",
  null
  
)

export default component.exports